const isGoogleAnalyticsInstalled = () => !!document.getElementById('gaTracker');

export default isGoogleAnalyticsInstalled;
